import axios from "axios";

export const createGenericTemplate = async (tokenC, detail) => {
  console.log(tokenC, detail);
  return await axios.post(
    `${process.env.REACT_APP_API}/genericTemplate/create`,
    detail,
    {
      headers: {
        // "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${tokenC}`,
      },
    }
  );
};

export const ListGenericTemplate = async (tokenC, page, perPage) => {
  return await axios.get(
    `${process.env.REACT_APP_API}/genericTemplate/list?page=${page || 1}&perPage=${
      perPage || 10
    }`,
    {
      headers: {
        Authorization: `Bearer ${tokenC}`,
      },
    }
  );
};


export const UpdateGenericTemplate = async (id, tokenC, detail) => {
  return await axios.put(
    `${process.env.REACT_APP_API}/genericTemplate/update/${id}`,
    detail,
    {
      headers: {
        // "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${tokenC}`,
      },
    }
  );
};

export const DeleteGenericTemplate = async (id, tokenC) => {
  // console.log(id, tokenC);
  return await axios.delete(
    `${process.env.REACT_APP_API}/genericTemplate/delete/${id}`,
    {
      headers: {
        Authorization: `Bearer ${tokenC}`,
      },
    }
  );
};